// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3L7lR","footer":"ModalInfo_footer__2lRYW"};